import { appConfiguration } from './app-configuration';
export const searchQueryConfiguration = 
// Filter for Hexon vehicles
{
    options: {
        page: {
            size: 150,
        },
        filters: {
            all: [
                { record_base_class: 'VanMossel\\Hexon\\HexonVoertuig' },
                { site_country: appConfiguration.country },
                { car_brand: 'Maxus' },
            ],
        },
        facets: {
            car_model: {
                type: 'value',
                name: 'model',
                size: 100,
            },
            nieuw_voertuig: {
                type: 'value',
                name: 'nieuwgebruikt',
                size: 100,
            },
            btw_marge: {
                type: 'value',
                name: 'btwmarge',
                size: 100,
            },
            dealer_title: {
                type: 'value',
                name: 'vestiging',
                size: 100,
            },
            overzichtsprijs: {
                type: 'range',
                name: 'Prijs',
                ranges: [{ from: 0, to: 99999999 }],
            },
            tellerstand: {
                type: 'range',
                name: 'Kilometerstand',
                ranges: [{ from: 0, to: 99999999 }],
            },
        },
        sort: {
            created: 'desc',
        },
    },
};
export const initialQueryConfiguration = 
// Filter for Hexon vehicles to create filteroptions from
{
    options: {
        page: {
            size: 20,
        },
        filters: {
            all: [
                { record_base_class: 'VanMossel\\Hexon\\HexonVoertuig' },
                { site_country: appConfiguration.country },
                { car_brand: 'Maxus' },
            ],
        },
        facets: {
            car_model: {
                type: 'value',
                name: 'model',
                size: 100,
            },
            nieuw_voertuig: {
                type: 'value',
                name: 'nieuwgebruikt',
                size: 100,
            },
            btw_marge: {
                type: 'value',
                name: 'btwmarge',
                size: 100,
            },
            dealer_title: {
                type: 'value',
                name: 'vestiging',
                size: 100,
            },
            overzichtsprijs: {
                type: 'range',
                name: 'Prijs',
                ranges: [{ from: 0, to: 99999999 }],
            },
            tellerstand: {
                type: 'range',
                name: 'Kilometerstand',
                ranges: [{ from: 0, to: 99999999 }],
            },
        },
        sort: {
            created: 'desc',
        },
    },
};
